module.exports = __webpack_public_path__ + "static/img/photo11.981de04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/photo11.png
// module id = b88c
// module chunks = 0